import React from 'react';
import {Link, withRouter} from 'react-router-dom';
import {store} from 'base/routes';
import {Videos} from 'api';
import {connect} from 'react-redux';
import CONFIG from 'base/constants/config';

class VideoBox extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  handleDelete(id, e) {
    if (confirm("Bạn có muốn xóa video này?")) {
      Videos.actions.delete.request({ id }).then(response => {
        this.props.deleteCallBack();
      });
    }
  }

  render() {

    return (
      <div className="media">
        <h3>
          {this.props.data.title}

          <Link to={`/videos/edit/${this.props.data.id}`} className="btn-actions"><span className="glyphicon glyphicon-pencil" aria-hidden="true"></span></Link> &nbsp;
          <a onClick={this.handleDelete.bind(this, this.props.data.id)} className="btn-actions"><span className="glyphicon glyphicon-remove" aria-hidden="true"></span></a>
        </h3>
        <div className="media-body">
          <p>Link: https://www.youtube.com/watch?v={this.props.data.linkId}</p>
        </div>
      </div>
    );
  }
}

export default withRouter(connect()(VideoBox));



// WEBPACK FOOTER //
// ./components/videos/VideoBox.jsx